/**
 * add to basket button Vue component
 *
 * @package citrus.vue.product.basket-button
 */
import {Vue} from "ui.vue";
import Button from "./components/button.vue";
import Price from "./components/price.vue";
import ButtonPrice from "./components/buttonPrice.vue";
import ButtonWithQuantity from "./components/buttonWithQuantity.vue";
import Quantity from "./components/quantity.vue";

Vue.component("CitrusProductBasketButton", Button);
Vue.component("CitrusProductBasketPrice", Price);
Vue.component("CitrusProductBasketQuantity", Quantity);
Vue.cloneComponent("CitrusProductBasketButtonPrice", "CitrusProductBasketButton", ButtonPrice);
Vue.cloneComponent("CitrusProductBasketButtonWithQuantity", "CitrusProductBasketButton", ButtonWithQuantity);
